// projectsData.js

import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import car from "../assets/png/carsRentalImage11.png"
import bus from "../assets/png/cars.png"
import centre from "../assets/png/centreFormation.png"
import promanager from "../assets/png/promanager.png"
import maintenance from "../assets/png/ramh.png"
import classroom from "../assets/png/classroom2.png"
import pedagonet from "../assets/png/pedagonet.png"




export const projectsData = [
    {
        id: 1,
        projectName: {
            en: 'RamhMaintenance',
            fr: 'RamhMaintenance'
        },
        projectDesc: {
            en: "A platform developed at RAM Handling to manage equipment and plan maintenance, allowing efficient tracking of breakdowns and scheduling of interventions.",
            fr: "Une plateforme développée chez RAM Handling pour gérer les équipements et planifier les maintenances, permettant un suivi efficace des pannes et la planification des interventions."
        },
        tags: ['Spring Boot', 'NextJS', 'UML', 'Docker','MySQL','JWT'],
        code: '', 
        demo: '',
        image: maintenance ,
        device: 'Desktop'
    },
    
    {
        id: 2,
        projectName: {
            en: 'TransBus',
            fr: 'TransBus'
        },
        projectDesc: {
            en: 'This project allows users to make online travel reservations and includes a back-office for resource management. It provides an interface for users to book trips, while the back-office helps manage various aspects of the transportation service.',
            fr: "Ce projet permet aux utilisateurs de faire des réservations de voyages en ligne et inclut un back-office pour la gestion des ressources. Il fournit une interface pour les utilisateurs afin de réserver des trajets, tandis que le back-office aide à gérer les différents aspects du service de transport."
        },
        tags: ['Laravel', 'JS', 'Bootstrap', 'MySQL'],
        code: 'https://github.com/anasszerhoun/TransBus',
        demo: 'https://educative-clone.vercel.app/',
        image: bus,
        device: 'Desktop'
    },
    {
        id: 3,
        projectName: {
            en: 'PedagoNet',
            fr: 'PedagoNet'
        },
        projectDesc: {
            en: 'PedagoNet is a mobile application that serves as a pedagogical social network. It enables students and school staff to post updates, interact with each other, and communicate seamlessly. The app also includes a classroom feature, similar to a real classroom, to support resource sharing and academic collaboration.',
            fr: "PedagoNet est une application mobile qui fait office de réseau social pédagogique. Elle permet aux étudiants et aux cadres de l’école de publier des posts, d’interagir entre eux et de communiquer facilement. L’application intègre également une fonctionnalité de classroom similaire à une salle de classe réelle, favorisant le partage de ressources et la collaboration académique."
        },
        tags: ['Flutter', 'NodeJs', 'Neo4j','MongoDB','JWT','UML'],
        code: 'https://github.com/anasszerhoun/TransBus',
        demo: 'https://educative-clone.vercel.app/',
        image: classroom,
        device:'Mobile'
    },
    {
        id: 4,
        projectName: {
            en: 'CarsRental',
            fr: 'CarsRental'
        },
        projectDesc: {
            en: 'This project allows users to rent cars online and includes a back-office for resource management. The application enables car search, booking, and management, while the back-office helps administrators track reservations and manage available vehicles.',
            fr: "Ce projet permet aux utilisateurs de louer des voitures en ligne et inclut un back-office pour la gestion des ressources. L'application permet la recherche, la réservation et la gestion des voitures, tandis que le back-office aide les administrateurs à suivre les réservations et à gérer les véhicules disponibles."
        },
        tags: ['ReactJS', 'SpringBoot', 'Tailwind', 'MySQL', 'Paypal API', 'JWT'],
        code: 'https://github.com/anasszerhoun/agenceDeLocation',
        demo: 'https://historythroughmovies.pythonanywhere.com/',
        image: car,
        device:'Desktop'
    },
    {
        id: 5,
        projectName: {
            en: 'ProManager',
            fr: 'ProManager'
        },
        projectDesc: {
            en: 'This is a Java-based application designed to help teachers track tasks and academic projects. It allows teachers to monitor the progress of various academic activities and manage assignments effectively.',
            fr: "Il s'agit d'une application basée sur Java conçue pour aider les enseignants à suivre les tâches et les projets académiques. Elle permet aux enseignants de suivre l'avancement des différentes activités académiques et de gérer efficacement les devoirs."
        },
        tags: ['Java', 'MongoDB', 'JavaFX', 'Google Calendar API'],
        code: 'https://github.com/anasszerhoun/ProManager',
        demo: 'https://practical-meninsky-36f305.netlify.app/',
        image: promanager,
        device:'Desktop'
    },
    {
        id: 6,
        projectName: {
            en: 'CentreFormation',
            fr: 'CentreFormation'
        },
        projectDesc: {
            en: 'This is a training center application offering three types of training. It provides features for registration, session tracking, and attendance management, helping both students and administrators keep track of training sessions and attendance.',
            fr: "Il s'agit d'une application de centre de formation proposant trois types de formations. Elle offre des fonctionnalités pour l'inscription, le suivi des sessions et la gestion de l'assiduité, aidant ainsi les étudiants et les administrateurs à suivre les sessions de formation et l'assiduité."
        },
        tags: ['HTML', 'CSS', 'JS', 'PHP', 'MySQL'],
        code: 'https://github.com/anasszerhoun/ProjetBD/tree/master/PROJET',
        demo: 'https://reliance-digital-clone.herokuapp.com/',
        image: centre,
        device:'Desktop'
    }    
]
